<ng-container [ngTemplateOutlet]="isMutualFund() ? mutualFundTemplate : defaultTemplate"
              [ngTemplateOutletContext]="{ $implicit: item, highlight: highlight }" />

<ng-template #defaultTemplate>
  <span class="td-wb-symbol-lookup-item-label__icon">
    <td-wb-icon-flag [value]="item.currency" />
  </span>
  <span class="td-wb-vh">&nbsp;</span>
  <span class="td-wb-symbol-lookup-item-label__symbol"
        [innerHtml]="item.symbol | tdWbSymbolLookupHighlight: { value: highlight }">
  </span>
  <span class="td-wb-vh">&nbsp;</span>
  <span class="td-wb-symbol-lookup-item-label__description"
        [innerHtml]="item.description | tdWbSymbolLookupHighlight: { value: highlight }">
  </span>
</ng-template>

<ng-template #mutualFundTemplate>
  <span class="td-wb-symbol-lookup-item-label__symbol"
        [innerHtml]="item.symbol | tdWbSymbolLookupHighlight: { value: highlight }">
  </span>
  <span class="td-wb-vh">&nbsp;</span>
  <span class="td-wb-symbol-lookup-item-label__description">
    <div class="td-wb-symbol-lookup-item-label__description--desc"
         [innerHtml]="item.description | tdWbSymbolLookupHighlight: { value: highlight }"></div>
    <span class="td-wb-vh">&nbsp;</span>
    @if (compact) {
      <div class="td-wb-symbol-lookup-item-label__load-type-container">
        <span class="td-wb-symbol-lookup-item-label__load-type"
              [translate]="'tdWb.components.symbolLookup.mutualFund.' + item.loadType">
        </span>
        <span class="td-wb-vh">&nbsp;</span>
        <div class="td-wb-symbol-lookup-item-label__currency" [innerText]="item.currency"></div>
      </div>
    }
  </span>
  @if (!compact) {
    <span class="td-wb-symbol-lookup-item-label__load-type"
          [translate]="'tdWb.components.symbolLookup.mutualFund.' + item.loadType">
    </span>
    <span class="td-wb-vh">&nbsp;</span>
    <div class="td-wb-symbol-lookup-item-label__currency"
         [innerText]="item.currency"></div>
  }
</ng-template>



